module.exports = __webpack_public_path__ + "img/rockola_stereo.ed97bf60.png";